import React from 'react';

const PhoneNumber = ({ number }) => {
  return !number ? null : (
    <span>{`(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`}</span>
  );
};

export default PhoneNumber;
